import React from 'react';

interface Stat {
  value: number | string | React.ReactNode;
  label: string;
  className?: string;
}

interface SummaryStatGroupCardProps {
  title?: string;
  icon?: React.ReactNode;
  stats: Stat[];
}

const SummaryStatGroupCard: React.FC<SummaryStatGroupCardProps> = ({ title, icon, stats }) => {
  return (
    <div className="summary-card p-3 border rounded bg-white shadow-sm">
      {/* Header */}
      {title && (
        <div className="d-flex align-items-center mb-2">
          {icon && <div className="me-2 text-secondary">{icon}</div>}
          <div className="fw-semibold text-muted">{title}</div>
        </div>
      )}

      {/* Stats Row */}
      <div className="d-flex justify-content-between text-center">
        {stats.map(({ value, label, className }, idx) => (
          <div key={idx} className="flex-grow-1">
            <div className={`fs-3 fw-bold ${className || ''}`}>{value}</div>
            <div className="text-muted small">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default SummaryStatGroupCard;
